export default __webpack_public_path__ + "static/media/fuelInspection.98ae34de.png";